/* eslint-disable complexity */
/* eslint-disable object-curly-newline */

/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-expressions */
import React from 'react';
import { wrapComponent } from 'utils/framework';
import helpersUtils from 'utils/Helpers';
import BaseClass from 'components/BaseClass';
import { breakpoints, mediaQueries, site, space, fontSizes } from 'style/config';
import store from 'store/Store';
import { Icon } from 'components/ui';
import Modal from 'components/Modal/Modal';
import Dropdown from 'components/Dropdown/Dropdown';
import CountCircle from 'components/CountCircle';
import userUtils from 'utils/User';
import analyticsUtils from 'analytics/utils';
import processEvent from 'analytics/processEvent';
import mediaUtils from 'utils/Media';
import localeUtils from 'utils/LanguageLocale';
import anaConsts from 'analytics/constants';
import Location from 'utils/Location';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import Storage from 'utils/localStorage/Storage';
import { DebouncedResize, TestTargetReady, UserInfoReady } from 'constants/events';
import InlineLoveListsHeader from 'components/Header/InlineLoves/InlineLoveListsHeader';
import InlineLovesList from 'components/Header/InlineLoves/InlineLovesList';
import LovesChunklets from 'components/Header/InlineLoves/LovesChunklets/LovesChunklets';
import GetTheseBeforeTheyreGone from 'components/Header/InlineLoves/GetTheseBeforeTheyreGone';
import Empty from 'constants/empty';
import MyListsBindings from 'analytics/bindingMethods/components/globalModals/myLists/myListsBindings';
import { MIN_ITEMS_PER_PAGE, MAX_ONLY_A_FEW_LEFT_IN_LOVES_LIST_FLYOUT, MAX_FLYOUT_RECENT_ITEMS } from 'constants/sharableList';

const getLovesUrl = () => '/profile/Lists';
const { deferTaskExecution } = helpersUtils;
const { Media } = mediaUtils;
const {
    ASYNC_PAGE_LOAD,
    PAGE_TYPES: { LOVES_MODAL, USER_PROFILE, MY_LISTS_FLYOUT },
    PAGE_NAMES: { MY_LISTS }
} = anaConsts;

const getText = text => localeUtils.getLocaleResourceFile('components/Header/InlineLoves/locales', 'InlineLoves')(text);

const handleLinkClick = (e, targetUrl, toggleModal) => {
    toggleModal && toggleModal();
    Location.navigateTo(e, targetUrl);
};

class InlineLoves extends BaseClass {
    state = {
        isOpen: false,
        isAnonymous: null,
        isLovesListPage: false,
        shouldDisplayOAFLProducts: false,
        shouldDisplaySaleProducts: false,
        shouldDisplayNotification: false,
        showLovesListSaleNotification: false,
        totalOnlyAFewLeftLoves: 0,
        totalOnSaleLoves: 0,
        skus: [],
        hasFetchedListsData: false
    };

    trackNavClick = () => {
        // Analytics are less priority than UI response, so defer them with low priority
        deferTaskExecution(() => {
            const navigationInfo = analyticsUtils.buildNavPath(['top nav', 'loves icon']);
            const smallViewport = !window.matchMedia(breakpoints.smMin).matches;

            if (smallViewport) {
                const pageType = LOVES_MODAL;
                const pageDetail = 'lists-loves modal';
                const pageName = `${USER_PROFILE}:${MY_LISTS}:${MY_LISTS_FLYOUT}:*`;

                // eslint-disable-next-line no-undef
                const previousPageName = digitalData.page.attributes.sephoraPageInfo.pageName;
                processEvent.process(ASYNC_PAGE_LOAD, {
                    data: {
                        pageName,
                        pageType,
                        pageDetail,
                        previousPageName,
                        navigationInfo
                    }
                });
            } else {
                analyticsUtils.setNextPageData({ navigationInfo });
            }
        });
    };

    handleLoveIconClick = e => {
        MyListsBindings.heartClick();

        const href = e?.currentTarget?.getAttribute('href');

        if (href) {
            Location.navigateTo(e, href);
        }
    };

    toggleModal = e => {
        e && e.preventDefault();

        if (this.props.disableModal) {
            return;
        }

        // CRITICAL: Update only the heart icon state first for immediate visual feedback
        this.setState({ isOpen: !this.state.isOpen });

        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    handleTrigger = isDropdownOpen => () => {
        this.setState({
            isOpen: isDropdownOpen
        });
    };

    handleMouseEnter = () => {
        if (!Sephora.isMobile()) {
            this.setState({ isHover: true });
        }
    };

    handleMouseLeave = () => {
        this.setState({ isHover: false });
    };

    render() {
        const { isLovesListPage } = this.state;

        if (isLovesListPage) {
            return this.getIcon();
        }

        return (
            <>
                {this.renderLGUI()}
                {this.renderSMUI()}
            </>
        );
    }

    renderShareable = ({ isSMUI = false } = {}) => {
        const { showLovesListSaleNotification, isAnonymous, isModalOpen } = this.state;
        const { isEmptyLists, limitedLoveListItems, recentlyItemsAdded = Empty.Object, SHOW_LOW_IN_STOCK_MAX } = this.props;
        const isAnonymousSharable = isAnonymous;
        const skus = recentlyItemsAdded;
        const emptyList = isEmptyLists;
        const totalFewLeft = limitedLoveListItems?.length > 5 ? SHOW_LOW_IN_STOCK_MAX : limitedLoveListItems.length || 0;
        const emptyFewLeft = totalFewLeft === 0;
        const lowInStockItems = limitedLoveListItems.slice(0, SHOW_LOW_IN_STOCK_MAX) || Empty.Array;

        return (
            <>
                {!isSMUI && emptyList && (
                    <InlineLoveListsHeader
                        title={getText('myLists')}
                        center={false}
                        fontSize={fontSizes.md}
                        showDivider={false}
                    ></InlineLoveListsHeader>
                )}
                {!emptyList && (
                    <InlineLoveListsHeader
                        title={getText('recentLists')}
                        linkURL={getLovesUrl()}
                        showLink={true}
                        callback={this.toggleModal}
                        isModalOpen={isModalOpen}
                        showDivider={false}
                    ></InlineLoveListsHeader>
                )}
                {!emptyList && (
                    <LovesChunklets
                        arrowWidth={10}
                        arrowCircleWidth={32}
                        lists={this.props?.myLists?.allLoves}
                        handleLinkClick={handleLinkClick}
                        toggleModal={isModalOpen && this.toggleModal}
                    ></LovesChunklets>
                )}
                {!emptyFewLeft && (
                    <InlineLoveListsHeader
                        title={getText('getTheseBeforeTheyAreGone')}
                        totalNotifications={totalFewLeft}
                        showDivider={false}
                        paddingBottom={4}
                        linkURL={getLovesUrl()}
                        showLink={true}
                        callback={this.toggleModal}
                        isModalOpen={isModalOpen}
                        paddingTop={0}
                    ></InlineLoveListsHeader>
                )}
                {!emptyFewLeft && <GetTheseBeforeTheyreGone skus={lowInStockItems} />}
                {!emptyList && (
                    <InlineLoveListsHeader
                        title={getText('recentlyAdded')}
                        linkURL={getLovesUrl()}
                        showLink={true}
                        callback={this.toggleModal}
                        isModalOpen={isModalOpen}
                    ></InlineLoveListsHeader>
                )}
                <InlineLovesList
                    toggleModal={isSMUI && this.toggleModal}
                    showLovesListSaleNotification={showLovesListSaleNotification}
                    handleLinkClick={handleLinkClick}
                    skus={skus}
                    isAnonymousSharable={isAnonymousSharable}
                ></InlineLovesList>
            </>
        );
    };

    renderLGUI = () => {
        const { isOpen, totalNotifications, isHover } = this.state;
        const itemLoveCount = this.props.limitedLoveListItems?.length >= 5 ? 5 : this.props.limitedLoveListItems?.length || 0;
        const shouldShowCountCircle = itemLoveCount > 0;

        return (
            <Media
                greaterThan='xs'
                css={{ height: '100%' }}
            >
                <Dropdown
                    id='loves_drop'
                    hasMaxHeight={true}
                    mouseEnterCallback={this.mouseEnterCallback}
                    position='static'
                    onTrigger={this.handleTrigger}
                    height='100%'
                    data-at={Sephora.debug.dataAt('loves_flyout')}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                >
                    <Dropdown.Trigger
                        zIndex={isOpen && 1}
                        aria-label={getText('loves')}
                        href={getLovesUrl()}
                        onClick={this.handleLoveIconClick}
                        css={styles.anchor}
                    >
                        {/* improve hover usability */}
                        <span
                            style={!isOpen ? { display: 'none' } : null}
                            css={{
                                position: 'absolute',
                                left: '50%',
                                bottom: -32,
                                marginLeft: -32,
                                width: 64,
                                height: 64,
                                transform: 'rotate(-45deg)'
                            }}
                        />
                        <div css={styles.iconWrap}>
                            <Icon
                                data-at={Sephora.debug.dataAt('love_icon_large')}
                                name={isOpen || isHover ? 'heart' : 'heartOutline'}
                            />
                            {shouldShowCountCircle && (
                                <CountCircle
                                    aria-label={totalNotifications === 1 ? getText('item') : getText('items')}
                                    key={`inlineLovesCount${totalNotifications}`}
                                    data-at={Sephora.debug.dataAt('loves_count')}
                                    children={itemLoveCount}
                                />
                            )}
                        </div>
                    </Dropdown.Trigger>
                    <Dropdown.Menu
                        width={this.props.dropWidth}
                        align='right'
                    >
                        {this.renderShareable()}
                    </Dropdown.Menu>
                </Dropdown>
            </Media>
        );
    };

    renderSMUI = () => {
        const title = getText('myLists');

        return (
            <Media at='xs'>
                {this.getIcon('small', this.toggleModal)}
                <Modal
                    isOpen={this.state.isModalOpen}
                    isDrawer={true}
                    onDismiss={this.toggleModal}
                    style={!this.state.isModalOpen ? { display: 'none' } : undefined}
                >
                    <Modal.Header>
                        <Modal.Title children={title} />
                    </Modal.Header>
                    <Modal.Body
                        paddingX={null}
                        paddingTop={null}
                        paddingBottom={null}
                    >
                        {this.renderShareable({ isSMUI: true })}
                    </Modal.Body>
                </Modal>
            </Media>
        );
    };

    // Extracted to avoid recreating function on each render
    iconClickHandler = onClick => e => {
        e && e.preventDefault();

        deferTaskExecution(() => {
            // Only call onClick (toggleModal) after heart is updated
            onClick && onClick(e);
            this.handleLoveIconClick();
        });

        return false; // Prevent default
    };

    getIcon = (view, onClick) => {
        const { isOpen, isLovesListPage, totalNotifications } = this.state;
        const WrapEl = isLovesListPage ? 'div' : 'a';
        const itemLoveCount = this.props.limitedLoveListItems?.length >= 5 ? 5 : this.props.limitedLoveListItems?.length || 0;
        const shouldShowCountCircle = itemLoveCount > 0;

        // Use the memoized handler
        const handler = this.iconClickHandler(onClick);

        return (
            <WrapEl
                {...(isLovesListPage || {
                    ['aria-label']: getText('loves'),
                    href: getLovesUrl(),
                    onClick: handler
                })}
                css={styles.anchor}
            >
                <div
                    onMouseEnter={this.mouseEnterCallback}
                    css={shouldShowCountCircle && styles.iconWrap}
                >
                    <Icon
                        data-at={Sephora.debug.dataAt(`love_icon${view ? '_' + view : ''}`)}
                        name={isOpen || isLovesListPage ? 'heart' : 'heartOutline'}
                    />
                    {!isLovesListPage && shouldShowCountCircle ? (
                        <CountCircle
                            aria-label={totalNotifications === 1 ? getText('item') : getText('items')}
                            key={`inlineLovesCount${totalNotifications}`}
                            data-at={Sephora.debug.dataAt('loves_count')}
                            children={itemLoveCount}
                        />
                    ) : null}
                </div>
            </WrapEl>
        );
    };

    mouseEnterCallback = () => {
        const { shouldDisplayNotification } = this.state;
        const isOnlyAFewLeftNotificationHidden = Storage.session.getItem(LOCAL_STORAGE.HIDE_OAFL_NOTIFICATION);

        if (shouldDisplayNotification && !isOnlyAFewLeftNotificationHidden) {
            this.setState({
                shouldDisplayNotification: false
            });
            Storage.session.setItem(LOCAL_STORAGE.HIDE_OAFL_NOTIFICATION, true);
        }
    };

    handleResize = () => {
        // close the modal if resizing above `xs` breakpoint
        if (this.state.isModalOpen) {
            if (window.matchMedia(breakpoints.smMin).matches) {
                this.toggleModal();
            }
        }
    };

    // Create a signature for a list of loves in the format of
    // 'skuId01:listName01|listName02|listName03,skuId02:listName08|listName09'
    getCurrentLovesSignature({ loves }) {
        return loves
            ?.map(item => {
                const { skuId } = item.sku;
                // Sort listNames to ensure stable ordering
                const listNames = item?.listNames && [...item?.listNames].sort().join('|');

                return `${skuId}:${listNames}`;
            })
            .sort()
            .join(',');
    }

    // Create a signature for a list of loves lists in the format of
    // 'listId01+listName01:skuId01,skuId02,skuId03|listId02+listName02:skuId67'
    getAllLovesSignature({ allLoves }) {
        if (!Array.isArray(allLoves)) {
            return '';
        }

        const loves = allLoves.map(loveList => {
            const shoppingListId = loveList.shoppingListId;
            const shoppingListName = loveList.shoppingListName;

            const skuIds = loveList.shoppingListItems.map(item => item.sku?.skuId).sort();

            return `${shoppingListId}+${shoppingListName}:${skuIds.join(',')}`;
        });

        return loves.sort().join('|');
    }

    componentDidUpdate(prevProps) {
        const { myLists, user, loves, getAllLists, getLimitedLoveListItems, fetchAllLovedItems } = this.props;
        const biAccountId = user?.beautyInsiderAccount?.biAccountId;
        // allLoves contains a list of all Love Lists, and each loved
        // sku (with sku details) inside of each list
        const allLoves = myLists?.allLoves;
        // currentLoves contains a list of recently loved skus, ordered by most recently
        // loved first, with the lists they were saved to but not the sku details
        const currentLoves = loves?.currentLoves || Empty.Array;
        const prevLoves = prevProps.loves?.currentLoves || Empty.Array;
        const prevAllLoves = prevProps.myLists?.allLoves || Empty.Array;

        if (biAccountId !== prevProps.user?.beautyInsiderAccount?.biAccountId && !this.state.hasFetchedListsData) {
            this.setState({ hasFetchedListsData: true });
            getAllLists({
                options: {
                    itemsPerPage: MIN_ITEMS_PER_PAGE
                }
            });

            if (!Location.isMyListsPage()) {
                getLimitedLoveListItems({ options: { itemsPerPage: MAX_ONLY_A_FEW_LEFT_IN_LOVES_LIST_FLYOUT } });
                fetchAllLovedItems();
            }
        }

        const currentLovesSignature = this.getCurrentLovesSignature({ loves: currentLoves });
        const prevCurrentLovesSignature = this.getCurrentLovesSignature({ loves: prevLoves });
        const allLovesSignature = this.getAllLovesSignature({ allLoves });
        const prevAllLovesSignature = this.getAllLovesSignature({ allLoves: prevAllLoves });

        // Check if the current loves have changed
        if (currentLovesSignature !== prevCurrentLovesSignature || allLovesSignature !== prevAllLovesSignature) {
            const skus = this.populateCurrentLoves({
                currentLoves: currentLoves.slice(0, MAX_FLYOUT_RECENT_ITEMS),
                allLoves
            });

            this.setState({
                skus,
                currentLoves,
                myLists: allLoves
            });
        }
    }

    populateCurrentLoves = ({ currentLoves, allLoves }) => {
        const skuDataMap = new Map();

        allLoves.forEach(list => {
            list.shoppingListItems.forEach(({ sku }) => {
                skuDataMap.set(sku.skuId, sku);
            });
        });

        // Build the resulting array in the same order as currentLoves, since
        // we want most recently loved first
        return currentLoves.map(({ sku, listNames }) => {
            const populatedSku = skuDataMap.get(sku.skuId) || {};

            return {
                ...populatedSku,
                skuId: sku.skuId,
                productId: sku.productId,
                transactionDate: sku.transactionDate,
                listNames
            };
        });
    };

    componentDidMount() {
        if (Location.isLovesListPage()) {
            this.setState({
                isLovesListPage: true
            });
        }

        // Watch user - no need to defer this initialization
        store.setAndWatch(
            'user',
            this,
            () => {
                this.setState({
                    isAnonymous: userUtils.isAnonymous()
                });
            },
            true
        );

        Sephora.Util.onLastLoadEvent(window, [UserInfoReady], () => {
            // Execute immediately when UserInfoReady event fires
            const showLoveListNotification = !(localeUtils.isCanada() && !Sephora.isMobile());
            const { user, getAllLists, getLimitedLoveListItems, fetchAllLovedItems, limitedLoveListItems } = this.props;

            if (showLoveListNotification) {
                const totalOnlyAFewLeftLoves = limitedLoveListItems.length;
                const totalNotifications = totalOnlyAFewLeftLoves;
                const shouldDisplayNotification = limitedLoveListItems.length > 0;
                const shouldDisplayOAFLProducts = totalOnlyAFewLeftLoves > 0;

                this.setState({
                    totalOnlyAFewLeftLoves,
                    totalNotifications,
                    shouldDisplayNotification,
                    shouldDisplayOAFLProducts
                });
            }

            if (!this.state.hasFetchedListsData) {
                if (user.beautyInsiderAccount) {
                    getAllLists({
                        force: false,
                        options: { itemsPerPage: MIN_ITEMS_PER_PAGE }
                    });
                    getLimitedLoveListItems({ options: { itemsPerPage: MAX_ONLY_A_FEW_LEFT_IN_LOVES_LIST_FLYOUT } });
                    fetchAllLovedItems();
                    this.setState({ hasFetchedListsData: true });
                }
            }
        });

        Sephora.Util.onLastLoadEvent(window, [UserInfoReady, TestTargetReady], () => {
            // Execute immediately when both events fire - no need to defer
            store.setAndWatch('testTarget', this, newOffers => {
                const showLovesListSaleNotification = !!newOffers.testTarget.offers?.lovesListSaleNotification?.show;

                if (showLovesListSaleNotification) {
                    const { onSaleInLovesList, onlyAFewLeftInLovesList } = this.props;
                    const totalOnSaleLoves = onSaleInLovesList?.length;
                    const totalOnlyAFewLeftLoves = onlyAFewLeftInLovesList?.length;
                    const totalNotifications = totalOnSaleLoves + totalOnlyAFewLeftLoves;
                    const isLovesNotificationHidden = Storage.session.getItem(LOCAL_STORAGE.HIDE_OAFL_NOTIFICATION);
                    const shouldDisplayNotification = totalOnSaleLoves > 0 && !isLovesNotificationHidden;
                    const shouldDisplayOAFLProducts = totalOnlyAFewLeftLoves > 0;
                    const shouldDisplaySaleProducts = totalOnSaleLoves > 0;

                    this.setState({
                        totalOnSaleLoves,
                        totalNotifications,
                        shouldDisplayNotification,
                        shouldDisplayOAFLProducts,
                        shouldDisplaySaleProducts,
                        showLovesListSaleNotification
                    });
                }
            });
        });

        window.addEventListener(DebouncedResize, this.handleResize);

        // Listen for CSF navigation to close modals - https://jira.sephora.com/browse/CSF-446
        window.addEventListener('csfNavigationStarted', this.handleCloseModals);

        // Listen for closeInlineLoves event
        window.addEventListener('closeInlineLoves', this.handleCloseModals);

        window.addEventListener('popstate', this.handleCloseModals);
    }

    componentWillUnmount() {
        window.removeEventListener(DebouncedResize, this.handleResize);
        // Unwatch csfNavigationStarted event
        window.removeEventListener('csfNavigationStarted', this.handleCloseModals);
        // Remove closeInlineLoves event listener
        window.removeEventListener('closeInlineLoves', this.handleCloseModals);

        window.removeEventListener('popstate', this.handleCloseModals);
    }

    handleCloseModals = () => {
        if (this.state.isModalOpen) {
            this.setState({ isModalOpen: false });
        }

        if (this.state.isOpen) {
            this.setState({ isOpen: false });
        }
    };
}

const styles = {
    anchor: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        height: site.headerHeight,
        paddingLeft: space[2],
        paddingRight: space[2],
        lineHeight: 0,
        [mediaQueries.sm]: {
            height: '100%',
            paddingTop: space[4],
            paddingBottom: space[4],
            paddingLeft: space[3],
            paddingRight: space[3]
        }
    },
    iconWrap: { position: 'relative' }
};

export default wrapComponent(InlineLoves, 'InlineLoves', true);
